module.exports = __webpack_public_path__ + "img/quad-cube-shifter.9a5afad6.gif";